import { get } from 'lodash';
import { formatCurrency } from '../../../../helpers/formatters';

export default {
    computed: {
        priceRange() {
            const currency =
                get(this, 'brief.brand.currency') ||
                get(this, 'campaign.brand.currency') ||
                get(this, 'currency') ||
                'usd';

            if ('selectedVariant' in this && this.selectedVariant) {
                return formatCurrency(this.selectedVariant.price, currency);
            }

            if (!this.product.variants || this.product.variants.length === 0) {
                return formatCurrency(this.product.price, currency);
            }

            const prices = this.product.variants.map(variant => variant.price);
            const minPrice = Math.min(...prices);
            const maxPrice = Math.max(...prices);

            if (minPrice === maxPrice) {
                return formatCurrency(minPrice, currency);
            }

            return `${formatCurrency(minPrice, currency)} - ${formatCurrency(maxPrice, currency)}`;
        }
    }
};
